'use strict';

function handlePostUpdate(messageType, message) {

    if ($('.update-messages').length === 0) {
        $('body').append(
            '<div class="update-messages"></div>'
        );
    }

    $('.update-messages').append(
        '<div class="alert ' + messageType + ' data-updated text-center" role="alert">' +
        message +
        '</div>'
    );

    setTimeout(function () {
        $('.data-updated').remove();
    }, 5000);
}

$(document).ready(function () {
    const urlParams = new URLSearchParams(window.location.search);
    const orderEmail = urlParams.get('orderEmail');
    const orderNo = urlParams.get('orderNo');
    if (orderNo && orderEmail) {
        $.spinner().start();
        $('#trackOrder-form-email').val(orderEmail);
        $('#trackOrder-form-orderNumber').val(orderNo);
        var $form = $('form.trackorder');
        var url = $form.attr('action');
        $.ajax({
            url: url,
            type: 'post',
            data: $form.serialize(),
            success: function (data) {
                $.spinner().stop();
                var newReturnsURL = location.href.split('?')[0];
                history.replaceState('Returns', document.title, newReturnsURL);
                if (data.success) {
                    if (data.orderExpired) {
                        $('.experience-dynamic-returnTrackOrder').parent().empty().append(data.html);
                    } else {
                        $('.experience-dynamic-returnTrackOrder').parent().parent().empty()
                            .append(data.html);
                        if (data.returnsPolicy) {
                            $('.returns__policy-js').empty().append(data.returnsPolicy);
                        }
                        if (data.returnsCustomerService) {
                            $('.returns__customer-service-js').empty().append(data.returnsCustomerService);
                        }
                    }
                } else {
                    if ($('.error-control').hasClass('d-none')) {
                        $('.error-control').removeClass('d-none');
                    }
                    $('.error-feedback').html('<strong>' + data.errorMessage + '</strong>');
                }
            },
            error: function (e) {
                $.spinner().stop();
            }
        });
    }

    if (sessionStorage.getItem('returnsConfirmationMessage')) {
        handlePostUpdate('alert-dark', 'Case created with success!');
        sessionStorage.removeItem('returnsConfirmationMessage');
        $.spinner().start();
        $.get($('.returns-success-js').val(), function (data) {
            $.spinner().stop();
            $('.experience-dynamic-returnTrackOrder').parent().empty().append(data.returnsSuccess);
        });
    }

    $('body').on('click', '.check-item, .stepper__button', function () {
        var checkBoxes = $('.check-item');
        var qty = 0;

        for (let i = 0; i < checkBoxes.length; i++) {
            let reason = $('#check-item-' + i).parent().parent().find('.reason');
            if (checkBoxes[i].checked) {
                $(reason).attr('required', '');
                if (!$('.error-control').hasClass('d-none')) {
                    $('.error-control').addClass('d-none');
                }
                qty += Number($('#check-item-' + i).parent().parent().find('.stepper__input')
                    .val());
            } else if ($(reason).attr('required')) {
                $(reason).removeAttr('required');
            }
        }
        $('.items-selected').text(qty);
    });

    $('body').on('submit', 'form.trackorder', function (e) {
        var $form = $(this);
        e.preventDefault();
        var url = $form.attr('action');
        $form.spinner().start();
        $.ajax({
            url: url,
            type: 'post',
            data: $form.serialize(),
            success: function (data) {
                $form.spinner().stop();
                if (data.success) {
                    if (data.orderExpired) {
                        $('.experience-dynamic-returnTrackOrder').parent().empty().append(data.html);
                    } else {
                        $('.experience-dynamic-returnTrackOrder').parent().parent().empty()
                            .append(data.html);
                        if (data.returnsPolicy) {
                            $('.returns__policy-js').empty().append(data.returnsPolicy);
                        }
                        if (data.returnsCustomerService) {
                            $('.returns__customer-service-js').empty().append(data.returnsCustomerService);
                        }
                    }
                } else {
                    if ($('.error-control').hasClass('d-none')) {
                        $('.error-control').removeClass('d-none');
                    }
                    $('.error-feedback').html('<strong>' + data.errorMessage + '</strong>');
                }
            },
            error: function (e) {
                $form.spinner().stop();
                /* location.reload(); */
            }
        });
    });

    $('body').on('submit', 'form.submit-return-form', function (e) {
        try {
            var description = {};
            var descriptionList = [];
            var checkBoxes = $('.check-item');
            var checked = [];
            var error = null;

            for (let i = 0; i < checkBoxes.length; i++) {
                if (checkBoxes[i].checked) {
                    checked.push(checkBoxes[i]);

                    if (!$(checkBoxes[i]).closest('.return-product__detail').find('.reason').val()) {
                        error = true;
                        break;
                    }
                }
            }

            if (!checked.length) {
                handlePostUpdate('alert-error', 'Must select one or more items to proceed!');
                e.preventDefault();
            } else if (error) {
                handlePostUpdate('alert-error', 'Must select one of the reason options!');
                e.preventDefault();
            } else if (window.grecaptcha && window.grecaptcha.getResponse() == '') {
                handlePostUpdate('alert-error', 'You must pass the reCAPTCHA!');
                e.preventDefault();
            }

            for (let j = 0; j < checked.length; j++) {
                description = {};
                var lineItem = $('#' + $(checked[j]).attr('id')).closest('.return-product__detail');
                description.UPC = lineItem.find('.line-item-sku').data('upc');
                description.SKU = lineItem.find('.line-item-sku').data('sku');
                description.Qty = Number(lineItem.find('.stepper__input').val());
                var attributes = $(lineItem).find('.line-item-attribute');
                for (let k = 0; k < attributes.length; k++) {
                    let currentAttr = $(attributes[k]);
                    description[$(currentAttr).data('value')] = currentAttr.find('#attr-value-' + k).text();
                }
                var option = lineItem.find('option');
                description.reason = option[lineItem.find('.reason').val()].innerText;
                descriptionList.push(description);
            }
            let comments = document.querySelector('.submit-return-form .custom-text-area').value;
            if (comments) {
                comments = `Comments: ${comments}`;
                descriptionList.push(comments);
            }
            $('#description').val(JSON.stringify(descriptionList));
            if (!$('#description').val()) {
                handlePostUpdate('alert-error', 'Must select one or more items to proceed!');
                e.preventDefault();
            }
            sessionStorage.setItem('returnsConfirmationMessage', true);
        } catch (e) {
            handlePostUpdate('alert-error', 'An error occur while processing your return. Please submit the return again.');
            e.preventDefault();
        }
    });
});
